<!-- POLICKO PRE STUD. PROGRAMY ZAZNAMU TEXTU PODPROGRAMU A BUTTON PRE ICH VYBER -->

<!-- TODO: toto pojde prec, ked zistim, na co tu bola pouzita class "stud-programy-margin-top"
 <div class="mt-2 mb-3"
    [ngClass]="{'stud-programy-margin-top' :
            ((mapaJazykovAFormArrays && poradie !== mapaJazykovAFormArrays.get(kodJazyk).length) || !somPoslednaOpakovanaPolozka)
            && typZaznamuTextu.idTypObjektu === TEXTAREA,
          'me-5' :
            ((mapaJazykovAFormArrays && poradie === mapaJazykovAFormArrays.get(kodJazyk).length) || somPoslednaOpakovanaPolozka)
            && (typZaznamuTextu.idTypObjektu === INPUT || typZaznamuTextu.idTypObjektu === TEXTAREA) ,
          'ms-4': typZaznamuTextu.opakovanie === 'A'}">
-->

<div class="mt-n2 mb-3"
    [ngClass]="{
          'me-5' :
            ((mapaJazykovAFormArrays && poradiePolozkyVoFormulari === mapaJazykovAFormArrays.get(kodJazyk).length) || somPoslednaOpakovanaPolozka)
            && (typZaznamuTextu.idTypObjektu === INPUT || typZaznamuTextu.idTypObjektu === TEXTAREA) ,
          'ms-4': typZaznamuTextu.opakovanie === 'A'
        }">

  <!-- <h4 class="mb-1" style="font-size:14px;">
    Študijné programy
  </h4> -->

  <div>

    <mat-card class="pb-2" style="border: solid rgb(0,0,0,0.2) 1px;">
      <div class="d-flex justify-content-between">

        <div class="p-2">
          <div *ngIf="!getStudProgramyZaznamu(poradiePolozkyVoFormulari); else studProgramy"
              style="color: rgba(0,0,0,.6);" i18n>

            Študijné programy - zoznam...
          </div>
          <ng-template #studProgramy>
            {{getStudProgramyZaznamu(poradiePolozkyVoFormulari)}}
          </ng-template>

        </div>


        <button mat-mini-fab color="primary" class="m-2"
          type="button"
          (click)="openStudijneProgramyDialog(poradiePolozkyVoFormulari)"
          [matTooltip]="getOpenStudProgramyDialogTooltip()">
          <mat-icon>playlist_add</mat-icon>
          <!-- <mat-icon>library_add</mat-icon> -->
        </button>

      </div>

    </mat-card>

    <!--
    <div class="border-stud-programy">

      <div class="d-flex justify-content-between px-2 py-2">

        <div style="padding-top: 10px;">
          <span class="align-middle" *ngIf="!mapaPoradiAStudProgramovZaznamu.get(i+1)">Študijné programy - zoznam...</span>
          {{getStuProgramyZaznamu(i+1)}}
        </div>

        <button mat-mini-fab color="primary"
          type="button"
          (click)="openStudijneProgramyDialog(i + 1)"
          matTooltip="Výber štud. programov {{i+1}}">
          <mat-icon>add</mat-icon>
        </button>

      </div>

    </div>
    -->

  </div>

</div>
